import { RouteLocationNormalized, START_LOCATION } from 'vue-router';
import _ from 'lodash';
import { sendSegmentPageview } from '../../lib/segment';

// Vue's START_LOCATION is { fullPath: '/', name: undefined, matched: [] }.
// Safari/WebKit can pass a copy of that object, so reference equality misses
// and we would send origin + "/" — the homepage referrer QA still sees there.
const isEntryPageview = (from: RouteLocationNormalized) =>
  from === START_LOCATION || (from.fullPath === '/' && !from.name && !from.matched?.length);

const segmentPageviews = (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  try {
    const componentTitle = (to.matched[0]?.components?.default as { name?: string })?.name;
    const processedName = _.startCase(_.replace((to.name as string) || '', /-/g, ' ')) || 'Unknown Page';

    const pageProperties: {
      title?: string;
      url: string;
      path: string;
      search?: string;
      referrer?: string;
    } = {
      title: componentTitle,
      url: document.location.href,
      path: document.location.pathname,
      search: document.location.search || undefined,
    };

    // In-app navigations use the previous Vue route. The entry pageview uses
    // document.referrer (login, geo, Google, etc.). Leave the key off when that
    // is empty so a direct tab does not send our homepage.
    if (!isEntryPageview(from) && from.fullPath) {
      pageProperties.referrer = document.location.origin + from.fullPath;
    } else if (document.referrer) {
      pageProperties.referrer = document.referrer;
    }

    sendSegmentPageview(`Sittercity-Web: ${processedName}`, pageProperties);
  } catch (error) {
    console.error('Segment tracking failed:', error);
  }
};

export default segmentPageviews;
